import "./cartItem.css";
import { useCartContext } from "../context";

const CartItem = ({ product }) => {
  const { title, price, image,quantity } = product;
  const {addToCart , removeFromCart} = useCartContext();

  const handleAdd = () => {
    addToCart(product);
  };
  const handleRemove = () => {
    removeFromCart(product);
  };

  return (
    <div className="cart-item-card">
      <div className="cart-item-img">
        <img src={image} alt="product" />
      </div>
      <div className="cart-item-details">
        <div className="title-price">
        <p>{title}</p>
        <span>${price}</span>
        </div>
        <div className="quantity">
        <div onClick={handleRemove} className="add">
          -
        </div>
        {quantity}
        <div className="add" onClick={handleAdd}>
          +
        </div>
      </div>
        </div>
      </div>
  );
};

export default CartItem;
